module.exports = __webpack_public_path__ + "static/media/checkmark--filled.0abc40a3.svg";